<template>
	<div
		@drop.prevent="onDrop($event)"
		@dragover.prevent
	>
		<v-file-input
			v-model="input"
			variant="outlined"
			v-bind="$attrs"
		/>
	</div>
</template>

<script>
export default {
	name: 'FileInput',
	props: {
		modelValue: {
			type: [File, Array, ],
			required: false,
			default: null
		}
	},
	emits: ['update:modelValue',],

	data () {
		return {
			input: null,
		};
	},

	watch: {
		input () {
			this.$emit('update:modelValue', this.input);
		},
	},

	methods: {
		/**
		 * Upload the files dragged
		 *
		 * @param {DragEvent} e
		 */
		onDrop (e) {
			if (!(this.$attrs.disabled === '' || this.$attrs.disabled === true)) {
				if (this.$attrs.multiple) {
					this.input = [];
					e.dataTransfer.files.forEach((element) => this.input.push(element));
				} else {
					this.input = [e.dataTransfer.files[0],];
				}
			}
		}
	}

};
</script>
